import api from '../api'

// Archive packages: one zip per station / source / month of files past the retention window.
// Backend endpoints are ADMIN only.
export default {

  getPackages(idStation) {
    return api.request('GET', '/archivePackage/list/' + idStation);
  },

  getDownload(id) {
    return api.request('GET', '/archivePackage/downloadfile/' + id);
  }

}
